<template>
  <div>
    <v-progress-linear v-if="loading"></v-progress-linear>
    <template v-if="modelObj.salereferencesharepoint_id">
      <document-manager orderOrOffer="order" class="pa-1" :modelObj.sync="modelObj" :module="moduleType" v-if="showDocuments"></document-manager>
    </template>
    <template v-else>
      <document-manager orderOrOffer="order" class="pa-1" :modelObj.sync="modelObj" :module="moduleType" v-if="showDocuments"></document-manager>
      <document-manager orderOrOffer="offer" class="pa-1" :modelObj.sync="offerObj" :module="moduleType" v-if="showOfferDocuments" :hidecreateupload="true"></document-manager>
    </template>
  </div>
</template>
<script>
export default {
  data () {
    return {
      modelObj: {},
      moduleType: null,
      loading: false,
      showDocuments: false,
      offerDocumentsLoading: false,
      showOfferDocuments: false,
      offerObj: {}
    }
  },
  components: {
    'document-manager': () => import('@/components/Documents/ModulesDocuments')
  },
  mounted () {
    this.getDetails()
    /* Load if sharepoint_id not set */
    this.$root.$on('get_orderfromoffer_details', () => {
      this.$router.go()
    })
  },
  methods: {
    getDetails () {
      this.loading = true
      this.moduleType = this.SP_ORDER
      this.$_executeApi('get', `orders/${this.$route.params.order_id}`).then(response => {
        this.modelObj = response.data
        if (this.modelObj.type !== 'offer' && this.modelObj.source_ref) {
          this.offerDocumentsLoading = true
          this.$_executeApi('get', `orders/${+this.modelObj.source_ref}`).then(response => {
            this.offerObj = response.data
            this.showOfferDocuments = true
            this.offerDocumentsLoading = false
          })
        }
        this.loading = false
        this.showDocuments = true
      })
    }
  },
  beforeDestroy () {
    this.$root.$off('get_orderfromoffer_details')
  }
}
</script>
